import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../service/helper/reduxHelper';
import { IPieceWorkTransaction } from '../../@types/model/pieceWorkTransaction/pieceWorkTransaction';

export default class PieceWorkTransactionActions {
    public static setIsLoading = createAction('PIECEWORK_SET_LOADING', withPayloadType<boolean>());
    public static setPieceworkData = createAction('PIECEWORK_SET_LIST', withPayloadType<Array<IPieceWorkTransaction> | null>());
}
